import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { makeStyles, useTheme } from '@mui/styles';
import clsx from 'clsx';

import Box from '@mui/material/Box';

import {
    blue,
    pumpkin,
    purple,
    orange,
    teal,
    olive,
    skyBlue,
    lavender,
    pointlessPuple,
    yellow,
    red,
    pointlessPink,
    neutrals1,
    neutrals2
} from '../data/colors';

const useStyles = makeStyles(theme => ({
    colors: {
        maxHeight: 150,
        overflowY: 'scroll',
    },
    colorrow: {
        display: 'flex',
        '& button': {
            margin: 4,
        },
        maxHeight: 150,
        maxWidth: 200,
    },
    colorButton: {
        display: 'flex',
        height: '15px',
        width: '15px',
        marginRight: '5px',
        marginBottom: '5px',
        borderRadius: '3px',
    },
    selected: {
        borderColor: `${theme.palette.text.primary} !important`,
        borderStyle: 'solid !important',
        borderWidth: '2px !important',
        width: '15px !important',
        height: '15px !important',
    },
    colorDisplay: {
        width: '92%',
        height: '25px',
        borderRadius: '3px',
        marginBottom: '5px',
    },
}));

const ColorButton = ({ color, selected, onClick }) => {
    const classes = useStyles();

    return (
        <Box
            className={clsx({
                [classes.colorButton]: true,
                [classes.selected]: (color || '').toLowerCase() === (selected || '').toLowerCase()
            })}
            style={{ background: color }}
            onClick={onClick}>
        </Box>
    );
};
ColorButton.propTypes = {
    color: PropTypes.string,
    selected: PropTypes.string,
    onClick: PropTypes.func,
};

const ColorSelector = (props) => {
    const classes = useStyles();
    const theme = useTheme();
    const [colors] = useState([
        Object.values(blue).slice(0, 9),
        Object.values(pumpkin).slice(0, 9),
        Object.values(purple).slice(0, 9),
        Object.values(orange).slice(0, 9),
        Object.values(teal).slice(0, 9),
        Object.values(olive).slice(0, 9),
        Object.values(skyBlue).slice(0, 9),
        Object.values(lavender).slice(0, 9),
        Object.values(pointlessPuple).slice(0, 9),
        Object.values(yellow).slice(0, 9),
        Object.values(red).slice(0, 9),
        Object.values(pointlessPink).slice(0, 9),
        // normal, warning, critical,
        Object.values(theme.SeverityColors),
        Object.values(neutrals1).slice(0, 3),
        Object.values(neutrals2).slice(0, 2),
    ]);

    const handleSelectColor = (c) => {
        props.onSelectColor(c);
    };

    return (
        <Box className={classes.colors}>
            {colors.map((row, j) =>
                <Box className={classes.colorrow} key={`colorrow-${j}`}>
                    {row.map((c, i) =>
                        <ColorButton
                            key={`colorbutton-${i}`}
                            onClick={() => handleSelectColor(c)}
                            color={c}
                            selected={props.color}/>
                    )}
                </Box>
            )}
        </Box>
    );
};

ColorSelector.propTypes = {
    color: PropTypes.string,
    onSelectColor: PropTypes.func.isRequired,
};

export const RandomColor = () => {
    const theme = useTheme();
    const colors = [...theme.SeverityColors, ...theme.ChartColors];
    return colors[Math.floor(Math.random() * colors.length)];
};

export {
    ColorSelector as default,
    ColorButton,
};
